import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { images } from "@/data/content";

export default function Problem({ onQuote }) {
  return (
    <section className="py-14 lg:py-20 bg-white" data-testid="problem-section">
      <div className="mx-auto max-w-7xl px-5 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_20px_60px_rgba(15,58,112,0.12)] aspect-[4/3]">
            <img
              src={images.faucet}
              alt="Discoloured water running from a household tap, showing why water system maintenance matters"
              className="w-full h-full object-cover"
            />
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-pristine-aquadeep mb-4">
              Water System Awareness
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-pristine-navy tracking-tight text-balance">
              Do You Know What Is Happening Inside Your Water System?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-pristine-navy/70 leading-relaxed">
              Your water may look clear while sediment, organic material and biofilm continue to build
              up inside tanks, pipes and filtration systems. Regular maintenance helps your water
              system operate more effectively and reduces the chance of avoidable water quality problems.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <Button
              data-testid="problem-assessment-cta"
              onClick={onQuote}
              className="mt-8 rounded-full bg-pristine-blue hover:bg-pristine-bluehover text-white h-13 px-7 py-3.5 text-base font-semibold group transition-transform hover:scale-[1.03]"
            >
              Arrange a Water System Assessment
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
